export default {"src":"/_next/static/media/error-free-1.457f6615.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};